import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase-config';

const formatDateFR = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toLocaleDateString('fr-FR');
};

const TimesheetPopup = ({ id, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Essayer d'abord workSessionsMonth (nouveau système)
        let docRef = doc(db, "workSessionsMonth", id);
        let docSnap = await getDoc(docRef);
        
        // Si pas trouvé, essayer workSessionsWeek (ancien système)
        if (!docSnap.exists()) {
          docRef = doc(db, "workSessionsWeek", id);
          docSnap = await getDoc(docRef);
        }
        
        if (docSnap.exists()) {
          setData({ id: docSnap.id, ...docSnap.data() });
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
      }}>
        <div style={{
          background: 'white',
          padding: 32,
          borderRadius: 12,
          textAlign: 'center'
        }}>
          Chargement...
        </div>
      </div>
    );
  }

  if (!data) {
    return null;
  }

  // Déterminer si c'est une feuille mensuelle ou hebdomadaire
  const isMonthly = data.monthName !== undefined;
  
  // Formater la période
  const periodText = isMonthly 
    ? `${data.monthName} ${data.year}`
    : `${formatDateFR(data.weekStart)} au ${formatDateFR(data.weekEnd)}`;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        padding: 32,
        borderRadius: 12,
        maxWidth: 400,
        width: '90%',
        textAlign: 'center'
      }}>
        <h3 style={{marginBottom: 16}}>Feuille de temps à signer</h3>
        <div style={{fontSize: 14, color: '#444', marginBottom: 16}}>
          <div><b>{data.employeeName || data.employeeEmail}</b></div>
          <div>Période : {periodText}</div>
        </div>
        <div style={{fontSize: 13, color: '#666', marginBottom: 20}}>
          {isMonthly 
            ? "Votre feuille de temps mensuelle a été validée par votre employeur et est prête à être signée."
            : "Votre feuille de temps a été validée par votre employeur et est prête à être signée."
          }
        </div>
        {isMonthly && (
          <div style={{fontSize: 12, color: '#ff9800', marginBottom: 20, fontWeight: 600}}>
            ⚠️ Sans signature, votre salaire ne pourra pas être versé.
          </div>
        )}
        <div style={{display: 'flex', gap: 12, justifyContent: 'center'}}>
          <button 
            style={{
              background: '#9c27b0',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              cursor: 'pointer',
              fontWeight: 600
            }}
            onClick={() => {
              onClose();
              navigate("/timesheet");
            }}
          >
            Aller aux feuilles de temps
          </button>
          <button 
            style={{
              background: '#666',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              cursor: 'pointer'
            }}
            onClick={onClose}
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimesheetPopup;